var map = {
	"./pages/home/home.module": [
		"./src/app/pages/home/home.module.ts",
		"pages-home-home-module"
	],
	"./pages/my-candidatutes/my-candidatutes.module": [
		"./src/app/pages/my-candidatutes/my-candidatutes.module.ts",
		"pages-my-candidatutes-my-candidatutes-module"
	],
	"./pages/my-cvs/my-cvs.module": [
		"./src/app/pages/my-cvs/my-cvs.module.ts",
		"pages-my-cvs-my-cvs-module"
	],
	"./pages/offres/offres.module": [
		"./src/app/pages/offres/offres.module.ts",
		"pages-offres-offres-module"
	],
	"./pages/stages/stages.module": [
		"./src/app/pages/stages/stages.module.ts",
		"pages-stages-stages-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;